import { useSyncExternalStore } from 'react';
import { onSketchObjectTypesChanged } from '../../potree/sketchObjects/registry';

let version = 0;
onSketchObjectTypesChanged(() => {
  version++;
});

/** A number that changes whenever the sketch-object registry or library config does — a render dependency. */
export const useSketchObjectRegistryVersion = (): number => useSyncExternalStore(onSketchObjectTypesChanged, () => version);
